import { Provider } from '@angular/core';
import { AllDatasourcesQuery, AllDatasourceTablesQuery } from '@y42/datasource';
import { Y42AllDatasourceTablesQuery } from './all-datasource-tables.query';
import { Y42AllDatasourcesQuery } from './all-datasources.query';

export function provideAllDatasourceQueries(): Provider[] {
  return [
    {
      provide: AllDatasourcesQuery,
      useClass: Y42AllDatasourcesQuery,
    },
    {
      provide: AllDatasourceTablesQuery,
      useClass: Y42AllDatasourceTablesQuery,
    },
  ];
}
